import React from 'react';
import { observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { Button, ControlLabel, ButtonToolbar } from 'react-bootstrap';
import Select from 'react-select-plus';
import 'react-select-plus/dist/react-select-plus.css';


@injectIntl @inject('rootStore', 'tasksStore', 'valuePropositionsStore') @observer
export default class ExistingTaskForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedVpElement: undefined,
            tasks: [],
            selectedTaskId: undefined,
        }
    }

    render() {
        const { intl, feedbackChain, valuePropositionsStore } = this.props;
        let tasksElement;
        if (this.props.tasksStore.loading || feedbackChain.updating) {
            tasksElement = <div className='tasks-toolbar'>
                <div className='text-center'>
                    <div className="main-loader">
                        <div className="loader-lg"></div>
                    </div>
                    <span>{intl.formatMessage({ id: 'existing_tasks_loading' })}</span>
                </div>
            </div>;
        }
        else {
            tasksElement = <TaskSelect
                tasks={this.state.tasks}
                selectedTaskId={this.state.selectedTaskId}
                handleClickTask={this.handleClickTask} />
        }
        const showAddButton = this.state.selectedTaskId;

        return (
            <div className="existing-task-form">
                <ControlLabel>{intl.formatMessage({ id: 'mvp_feature_select_label' })}</ControlLabel>
                <div>
                    <Select options={valuePropositionsStore.selectableMvpsBoards(feedbackChain.valuePropositionId)}
                        value={this.state.selectedVpElement}
                        onChange={this.handleSelect}
                        placeholder={intl.formatMessage({ id: 'vp_element_select_placeholder' })}
                        clearable={false}
                    />
                </div>
                <br />
                <div>
                    {tasksElement}
                </div>
                <ButtonToolbar>
                    {showAddButton && (
                        <Button className={'pull-right'} bsStyle={"primary"}
                            onClick={() => feedbackChain.setCardId(this.state.selectedTaskId)} >
                            {intl.formatMessage({ id: "bind_task" })}
                        </Button>
                    )
                    }
                </ButtonToolbar>
            </div>
        );
    }


    handleSelect = (selectedVpElement) => {
        this.setState({
            selectedVpElement: selectedVpElement,
        });
        if (selectedVpElement) {
            this.props.tasksStore.getTasksByBoardId(selectedVpElement.value.id).then((tasks) => {
                this.setState({
                    tasks: tasks,
                });
            });
        }
    }

    handleAddTask = (taskId) => {
        this.setState({
            selectedTaskId: taskId,
        })
    }

    handleRemoveTask = () => {
        this.setState({
            selectedTaskId: undefined,
        })
    }

    handleClickTask = (taskId) => {
        if (this.state.selectedTaskId == taskId) {
            this.handleRemoveTask();
        }
        else {
            this.handleAddTask(taskId);
        }

    }
}

@injectIntl @observer
class TaskSelect extends React.Component {
    render() {
        return (
            <div>
                {this.props.tasks.length > 0 &&
                    <span className="small text-muted">
                        {this.props.intl.formatMessage({ id: 'select_task_title' })}
                    </span>
                }
                <div className='tasks-lists'>
                    {this.props.tasks.map((task, idx) => {
                        const isSelectedTask = this.props.selectedTaskId == task.id;
                        const selectedTaskClass = isSelectedTask ? 'selected' : '';
                        return (<div className={'task relative-position ' + selectedTaskClass}
                            key={idx}
                            onClick={() => this.props.handleClickTask(task.id)}>
                            {!this.props.selectedTaskId && <i className='fa fa-check btn-transparent top-right' />}
                            {isSelectedTask && <i className='fa fa-remove btn-transparent top-right' />}
                            {task.name}
                        </div>);
                    })
                    }
                </div>
            </div>
        );
    }
}
